var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8081 5.44194C10.564 5.19786 10.564 4.80214 10.8081 4.55806C11.0521 4.31398 11.4479 4.31398 11.6919 4.55806L16.6091 9.47524C16.9636 9.70948 16.9636 10.2905 16.6091 10.5248L11.6919 15.4419C11.4479 15.686 11.0521 15.686 10.8081 15.4419C10.564 15.1979 10.564 14.8021 10.8081 14.5581L14.7411 10.625H3.75C2.91667 10.625 2.91667 9.375 3.75 9.375H14.7411L10.8081 5.44194Z", fill: "#303030" })
  );
});